import React from 'react'

import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

const MinimalModal = (props) => {
  const hideModal = () => {
    props.callback(null)
  }

  return (
    <Modal
      show={ props.message !== null }
      onHide={ hideModal }
      id='minimalModal'
      dialogClassName='minimalModal'
      backdrop='static'
      keyboard={ true }
      onEscapeKeyDown={ hideModal }
    >
      <Modal.Body style={{whiteSpace: 'pre-line'}}>
        { props.message }
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='oceamo'
          onClick={ hideModal }
          className='button'
        >
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default MinimalModal
